import { Switch, Transition } from "@headlessui/react";
import { Fragment, useEffect } from "react";

import useTheme from "hooks/useTheme";

import { useDispatch, useSelector } from "react-redux";
import DeviceIcon from "theme/icons/Device";
import MailIcon from "theme/icons/Mail";
import { getAllAccountsByUser, updateAccountInfoByID, updateAccountListSortByUserID } from "actions/accounts";
import useNotification from "hooks/useNotification";

const Notifications = () => {
	const dispatch = useDispatch();
	const { appLanguage, themeColor } = useTheme();
	const { notify } = useNotification();

	const accounts = useSelector((state) => state.Accounts);

	useEffect(() => {
		dispatch(getAllAccountsByUser());

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleChange = async (e, index, deviceType, notificationType) => {
		const accountPreferences = accounts?.[index];

		accountPreferences["notification-preferences"][deviceType][notificationType] = e;

		accounts[index] = accountPreferences;

		dispatch(updateAccountListSortByUserID(accounts, notify));
	};

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
		>
			<div className="items-center justify-content w-[50%] flex-col px-5 space-y-2">
				{/* <div className={`flex items-center w-full space-x-4 border-b-2 ${themeColor?.border}`}>
					<h1 className={`w-full text-xl font-bold ${themeColor?.text} pb-1`}>Notification Preferences</h1>
				</div> */}

				<div className={`flex flex-col w-full items-center justify-start space-y-10 py-7`}>
					<div className={`flex flex-col w-full items-start justify-start space-y-3`}>
						<div className="flex space-x-4">
							<DeviceIcon className="w-4" fill={themeColor?.hex} />
							<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.onDeviceNotifications}</p>
						</div>

						<div className="flex flex-col w-full items-start justify-start space-y-1">
							<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.whenIReceive}</p>

							{accounts?.map((account, index) => (
								<div className={`flex w-full items-center justify-start space-x-4 `} key={index}>
									<div className="w-3"></div>
									<p className={`w-full text-sm ${themeColor?.text}`}>{account?.name}</p>

									<Switch
										defaultChecked={account?.["notification-preferences"]?.["device-notification"]?.receive}
										onChange={(e) => handleChange(e, index, "device-notification", "receive")}
										as={Fragment}
									>
										{({ checked }) => (
											<button
												className={`${
													checked ? themeColor?.bg : `${themeColor?.bg} bg-opacity-20`
												} relative inline-flex h-5 w-10 shrink-0 rounded-full smooth border-2 border-transparent`}
											>
												<span
													className={`${
														checked ? "translate-x-5" : "translate-x-0"
													} h-4 w-4 rounded-full bg-white shadow-xl smooth`}
												/>
											</button>
										)}
									</Switch>
								</div>
							))}
						</div>
						<div className="flex flex-col w-full items-start justify-start space-y-1">
							<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.whenISend}</p>

							{accounts?.map((account, index) => (
								<div className={`flex w-full items-center justify-start space-x-4 `} key={index}>
									<div className="w-3"></div>
									<p className={`w-full text-sm ${themeColor?.text}`}>{account?.name}</p>

									<Switch
										defaultChecked={account?.["notification-preferences"]?.["device-notification"]?.send}
										onChange={(e) => handleChange(e, index, "device-notification", "send")}
										as={Fragment}
									>
										{({ checked }) => (
											<button
												className={`${
													checked ? themeColor?.bg : `${themeColor?.bg} bg-opacity-20`
												} relative inline-flex h-5 w-10 shrink-0 rounded-full smooth border-2 border-transparent`}
											>
												<span
													className={`${
														checked ? "translate-x-5" : "translate-x-0"
													} h-4 w-4 rounded-full bg-white shadow-xl smooth`}
												/>
											</button>
										)}
									</Switch>
								</div>
							))}
						</div>
					</div>

					<div className={`flex flex-col w-full items-start justify-start space-y-3`}>
						<div className="flex space-x-4">
							<MailIcon className="w-4" fill={themeColor?.hex} />
							<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.emailNotifications}</p>
						</div>

						<div className="flex flex-col w-full items-start justify-start space-y-1">
							<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.whenIReceive}</p>

							{accounts?.map((account, index) => (
								<div className={`flex w-full items-center justify-start space-x-4 `} key={index}>
									<div className="w-3"></div>
									<p className={`w-full text-sm ${themeColor?.text}`}>{account?.name}</p>

									<Switch
										defaultChecked={account?.["notification-preferences"]?.["email-notification"]?.receive}
										onChange={(e) => handleChange(e, index, "email-notification", "receive")}
										as={Fragment}
									>
										{({ checked }) => (
											<button
												className={`${
													checked ? themeColor?.bg : `${themeColor?.bg} bg-opacity-20`
												} relative inline-flex h-5 w-10 shrink-0 rounded-full smooth border-2 border-transparent`}
											>
												<span
													className={`${
														checked ? "translate-x-5" : "translate-x-0"
													} h-4 w-4 rounded-full bg-white shadow-xl smooth`}
												/>
											</button>
										)}
									</Switch>
								</div>
							))}
						</div>
						<div className="flex flex-col w-full items-start justify-start space-y-1">
							<p className={`text-md font-bold ${themeColor?.text}`}>{appLanguage?.whenISend}</p>

							{accounts?.map((account, index) => (
								<div className={`flex w-full items-center justify-start space-x-4 `} key={index}>
									<div className="w-3"></div>
									<p className={`w-full text-sm ${themeColor?.text}`}>{account?.name}</p>

									<Switch
										defaultChecked={account?.["notification-preferences"]?.["email-notification"]?.send}
										onChange={(e) => handleChange(e, index, "email-notification", "send")}
										as={Fragment}
									>
										{({ checked }) => (
											<button
												className={`${
													checked ? themeColor?.bg : `${themeColor?.bg} bg-opacity-20`
												} relative inline-flex h-5 w-10 shrink-0 rounded-full smooth border-2 border-transparent`}
											>
												<span
													className={`${
														checked ? "translate-x-5" : "translate-x-0"
													} h-4 w-4 rounded-full bg-white shadow-xl smooth`}
												/>
											</button>
										)}
									</Switch>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</Transition>
	);
};

export default Notifications;
